import { PLATFORMS } from "./constants";
import type { Platform } from "./types";

/** 임의의 값이 유효한 Platform 인지 좁혀 준다. 푸시 구독 등록 등에서 클라이언트가
 * 보낸 platform 값을 서버가 검증할 때 쓴다. */
export const isPlatform = (v: unknown): v is Platform =>
  typeof v === "string" && (PLATFORMS as readonly string[]).includes(v);

/**
 * 네이티브 브리지(Capacitor)가 주입하는 전역 객체에서 실행 플랫폼 문자열을 읽는다
 * ("android"/"ios"/"web", 브리지 없으면 undefined). @capacitor/core 를 import 하지
 * 않는다 — import 하면 웹 번들에도 딸려 들어가고, 웹에선 어차피 "web" 을 반환하므로
 * 전역만 읽어 판정한다. apps/app 의 detectPlatform() 과 @app/ui 의 Haptics 가 이 한
 * 함수를 공유한다(패키지 경계를 넘는 중복 구현을 막는다).
 */
export const getCapacitorPlatform = (): string | undefined => {
  const cap = (globalThis as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
  return cap?.getPlatform?.();
};

/** Capacitor 네이티브 셸(android/ios)에서 실행 중인지. web/desktop 은 false. */
export const isCapacitorNative = (): boolean => {
  const platform = getCapacitorPlatform();
  return platform === "android" || platform === "ios";
};
